import * as React from 'react'
import { constants } from '../constants'
import styled from 'styled-components'
import { StyledAnchor } from './common/StyledLink'
import LinkOut from '../assets/link-out.svg'
import TitleImage from './common/TitleImage'

interface Props {
  messages: any
  titleImg?: any
}

const SubFooter = ({ messages, titleImg }: Props) => {
  return (
    <Wrapper>
      <InnerWrapper>
        <Title>
          {titleImg ? (
            <TitleImage
              spWidth="151px"
              pcWidth="216px"
              src={titleImg}
              alt={messages.subFooter.title}
            />
          ) : (
            messages.subFooter.title
          )}
        </Title>
        <LinkList>
          <LinkListItem>
            <Link href={messages.links[0].url} target="_blank">
              {messages.links[0].title}
            </Link>
            <Link href={messages.links[3].url} target="_blank">
              {messages.links[3].title}
            </Link>
          </LinkListItem>
          <LinkListItem>
            <Link href={messages.links[1].url} target="_blank">
              {messages.links[1].title}
            </Link>
            <Link href={messages.links[4].url} target="_blank">
              {messages.links[4].title}
            </Link>
          </LinkListItem>
          <LinkListItem>
            <Link href={messages.links[2].url} target="_blank">
              {messages.links[2].title}
            </Link>
            <Link href={messages.links[5].url} target="_blank">
              {messages.links[5].title}
            </Link>
          </LinkListItem>
        </LinkList>
        <LinkListSP>
          <Link href={messages.links[0].url} target="_blank">
            {messages.links[0].title}
          </Link>
          <Link href={messages.links[1].url} target="_blank">
            {messages.links[1].title}
          </Link>
          <Link href={messages.links[2].url} target="_blank">
            {messages.links[2].title}
          </Link>
          <Link href={messages.links[3].url} target="_blank">
            {messages.links[3].title}
          </Link>
          <Link href={messages.links[4].url} target="_blank">
            {messages.links[4].title}
          </Link>
          <Link href={messages.links[5].url} target="_blank">
            {messages.links[5].title}
          </Link>
        </LinkListSP>
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${constants.colors.background.gray};
`

const InnerWrapper = styled.div`
  margin: 0 ${constants.spacing.sp.medium};
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    width: ${constants.dimensions.contentsPercent};
    margin: 0 auto;
  }
`

const Title = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin: 32px 0 32px;
  display: flex;
  justify-content: center;
  color: #777777;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    font-size: 28px;
  }
`

const LinkList = styled.div`
  display: none;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 36px;
  }
`

const LinkListSP = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    display: none;
  }
`

const LinkListItem = styled.div``

const Link = styled(StyledAnchor)`
  display: block;
  position: relative;
  font-size: 16px;
  color: #484848;
  letter-spacing: 0.47px;
  padding-left: 27px;
  padding-right: 8px;
  margin-bottom: 36px;

  &:before {
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background-image: url(${LinkOut});
    width: 15px;
    height: 15px;
    background-repeat: no-repeat;
  }

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    margin-bottom: 12px;
    font-size: 14px;
  }
`

export default SubFooter
